/* eslint-disable import/no-unresolved */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";

import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import PowerBIAccess from "../../../dataAccess/PowerBIAccess";
import "powerbi-report-authoring";
import { useLocation } from "react-router-dom";

const PowerBiChart = (props) => {
  // const { location: { state: { reportId, datasetId } } } = props;
  const location = useLocation();

  const datasetId = location.state?.datasetId;
  const reportId = location.state?.reportId;
  const measureId = location.state?.measureId;
  const clientId = location.state?.clientId;

  const reportClass = "report-container";
  const [sampleReportConfig, setReportConfig] = useState({
    type: "report",
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: undefined,
  });

  useEffect(() => {
    PowerBIAccess.getAccessToken().then((response) => {
      let accessToken = response.data.access_token;
      // Power BI workspace differs per environment; infer env from the API path (prism_dev_api_v2 / prism_qa_api_v2)
      const isDev = (process.env.REACT_APP_API_PATH || "").toLowerCase().includes("_dev_");
      let groupId = isDev
        ? "9c08aedc-a169-406a-a0eb-95e4f299391f" // DEV
        : "a597f379-21a5-488a-b5ed-bd2602dc8e74"; // QA
      if (accessToken) {

        // Fetch the report first so the embed token uses the report's own dataset
        PowerBIAccess.getReportById(reportId, accessToken, groupId)
          .then((res) => res.json())
          .then((report) => {
            const reportDatasetId = report.datasetId || datasetId;
            return PowerBIAccess.getPowerBIEmbeddedToken(reportDatasetId, reportId, accessToken)
              .then((response) => response.json())
              .then((result) => {
                embedPowerBIReport(result.token, report.embedUrl, reportId);
              });
          })
          .catch((error) => console.log("error", error));
      }
    });
  }, []);

 function embedPowerBIReport(token, url, embedReportId) {
  const config = {
    type: "report",
    tokenType: models.TokenType.Embed,
    accessToken: token,
    embedUrl: url,
    id: embedReportId,
    permissions: models.Permissions.All,
    filters: [
      {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Reports",
          column: "MeasureID",
        },
        operator: "In",
        values: [Number(measureId)],
      },
      {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Clients",
          column: "UserID",
        },
        operator: "In",
        values: [Number(clientId)],
      }
    ],
    settings: {
      panes: {
        filters: { visible: false },
        pageNavigation: { visible: false },
      },
      bars: {
        statusBar: { visible: false },
      },
    },
  };
  setReportConfig(config);
}
  return (
    <div>
      {sampleReportConfig && sampleReportConfig.embedUrl && (
        <PowerBIEmbed
          cssClassName={reportClass}
          embedConfig={sampleReportConfig}
        />
      )}
    </div>
  );
};

export default PowerBiChart;
